import { globalLoadingWithProgressSelector } from "@redux/ui"
import { t } from "i18next"
import { ProgressBar, Modal } from "react-bootstrap"
import { useSelector } from "react-redux"

const LoadingWithProgress = () => {
	const progress = useSelector(globalLoadingWithProgressSelector)
	if (typeof progress !== "number") return null
	return (
		<Modal show backdrop="static" centered className="d-flex justify-content-center" contentClassName="bg-transparent border-0">
			<div className="d-flex flex-column justify-content-center align-items-center">
				<ProgressBar style={{ width: 300 }} animated now={progress} max={1} />
				<h1 className="text-light mt-3">
					{t("Ladataan")} {(progress * 100).toFixed(0)}% ...
				</h1>
			</div>
		</Modal>
	)
}

export default LoadingWithProgress
